import dayjs from "dayjs";

export interface IReportingPeriodParts {
  lines: string[];
}

export const getReportingPeriodParts = (startDate: Date | string, endDate: Date | string): IReportingPeriodParts => {
  const start = dayjs(startDate);
  const end = dayjs(endDate);

  // Check full year: Jan 1 to Dec 31 of same year
  if (
    start.date() === 1 &&
    start.month() === 0 &&
    end.date() === 31 &&
    end.month() === 11 &&
    start.year() === end.year()
  ) {
    return { lines: [start.format("YYYY")] };
  }

  // Check full month: 1st of month to last day of same month
  if (
    start.date() === 1 &&
    end.date() === start.endOf("month").date() &&
    start.month() === end.month() &&
    start.year() === end.year()
  ) {
    return { lines: [start.format("MMMM"), start.format("YYYY")] };
  }

  // Fallback: date range
  return { lines: [`${start.format("DD.MM.YYYY")} – ${end.format("DD.MM.YYYY")}`] };
};

export const getReportingPeriodLabel = (startDate: Date | string, endDate: Date | string): string => {
  return getReportingPeriodParts(startDate, endDate).lines.join(" ");
};
